"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Window = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Window = function Window(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Window_svg__Window_svg__clip0_28081_614)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.15 7.284H0V8.31h2.15V7.284zM14.281 0H0v6.863h2.15C2.823 5.536 3.641 2.265 3.996.77h8.008c.355 1.495 1.173 4.766 1.846 6.093H16V0h-1.719zm-2.329 13.598H4.048L2.024 8.735H0v6.988s.759.623 2.15 0c1.392-.624 1.392.499 2.783 0l-.564-1.355h7.262l-.564 1.355c1.392.499 1.392-.624 2.783 0 1.391.623 2.15 0 2.15 0V8.735h-2.024l-2.024 4.863zM16 7.284h-2.15V8.31H16V7.284z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.669 9.52l.22.227 5.171-5.306-.22-.227-5.171 5.307zm5.634-1.629l-.221-.227-3.58 3.674.221.227 3.58-3.674z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Window_svg__Window_svg__clip0_28081_614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 1,
    fill: "#fff"
  }))));
};

exports.Window = Window;
var _default = Window;
exports.default = _default;